import request from "../Tools/request/request";
// 社区管理帖子分页查询
export function posts(data) {
    return request({
        url: "/community/postdata/posts",
        method: "post",
        data,
    });
}
// 发帖
export function push(data) {
    return request({
        url: "/community/postdata/push",
        method: "post",
        data,
    });
}
// 社区管理举报分页查询
export function repotlist(data) {
    return request({
        url: "/community/postdata/repotlist",
        method: "post",
        data,
    });
}

export function deletePost(data) {
    return request({
        url: "/community/postdata/delete",
        method: "post",
        data,
    });
}